import { useEffect, useRef } from 'react'
import { prepareAdGeneration } from '../services/api'
import { preparationKey, preparationRequest } from '../utils/generationPreparation'

// Long enough that a typed address is finished, short enough to be done before "Generate".
const PREPARE_DELAY_MS = 1500

function newReference() {
  return typeof crypto !== 'undefined' && crypto.randomUUID ? `draft-${crypto.randomUUID()}` : `draft-${Date.now()}`
}

/**
 * Sends a preparation once the form's sources settle, and again only when they change.
 * Fire and forget: "Generate" never waits for it, and a failed one costs nothing but the head start.
 */
export function useGenerationPreparation({ apiBase, sources, adId, enabled }) {
  // An unsaved ad has no id: one reference per editor session lets the agent replace this ad's
  // previous preparation when the sources change.
  const draftReference = useRef(null)
  if (!draftReference.current) draftReference.current = newReference()
  const request = enabled ? preparationRequest(sources, adId || draftReference.current) : null
  const key = preparationKey(request)
  const latest = useRef(request)
  latest.current = request
  const sentKey = useRef(null)

  useEffect(() => {
    if (!key || key === sentKey.current) return undefined
    const timer = setTimeout(() => {
      sentKey.current = key
      prepareAdGeneration(apiBase, latest.current).catch(() => {})
    }, PREPARE_DELAY_MS)
    return () => clearTimeout(timer)
  }, [apiBase, key])
}
